import React, { Component } from 'react'
import axios from 'axios'
import { Container, Row, Col, Table, Input, Button, NavLink } from 'reactstrap'
import { Link } from 'react-router-dom'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'

import * as dataActions from '../actions/dataActions'

function loadContent (x) {
  axios({
    method: 'get',
    url: `${process.env.REACT_APP_API_URL}/content`,
    headers: {
      'Authorization': 'Bearer ' + sessionStorage.getItem('token')
    }
  }).then((res) => {
    x.setState({
      content: res.data
    })
  })
}

class Search extends Component {
  constructor (props) {
    super(props)
    this.state = {
      title: '',
      content: []
    }
    this.handleChange = this.handleChange.bind(this)
    this.publishContent = this.publishContent.bind(this)
    this.archiveContent = this.archiveContent.bind(this)
    this.sendContentID = this.sendContentID.bind(this)
    this.deleteContent = this.deleteContent.bind(this)
  }

  componentWillMount () {
    loadContent(this)
  }

  handleChange (e) {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  publishContent (e) {
    axios({
      method: 'POST',
      url: `${process.env.REACT_APP_API_URL}/content/publish/${e.target.id}`,
      headers: {
        'Authorization': 'Bearer ' + sessionStorage.getItem('token')
      }
    }).then(() => {
      loadContent(this)
    })
  }

  archiveContent (e) {
    axios({
      method: 'POST',
      url: `${process.env.REACT_APP_API_URL}/content/archive/${e.target.id}`,
      headers: {
        'Authorization': 'Bearer ' + sessionStorage.getItem('token')
      }
    }).then(() => {
      loadContent(this)
    })
  }
/*
GET /contents?filter1=&filter2=...&paginate=...
POST /contents
  body = "content"'s content
  return { id : id }
GET /contents/:id
  return content id content
PUT /contents/:id
  body = changes to do
  return {id:id} OU content id content
DELETE /contents/:id
  body = null
  return {id:id} OU content id content
GET /contents/:id/comments
GET /contents/:id/comments/:id
GET /contents/:id/status
PUT /contents/:id/status
  body = new status
*/
  deleteContent (e) {
    axios({
      method: 'DELETE',
      url: `${process.env.REACT_APP_API_URL}/content/delete/${e.target.id}`,
      headers: {
        'Authorization': 'Bearer ' + sessionStorage.getItem('token')
      }
    }).then(() => {
      loadContent(this)
    })
  }

  sendContentID (e) {
    // this.props.dataActions.fetchContentID(e.target.id)
    this.props.dataActions.passArticleID(e.target.id)
  }

  render () {
    let contentList = this.state.content
      .filter(content => content.title.toLowerCase().includes(this.state.title.toLowerCase()) === true )

    return (
      <Container className={'mT-5'}>
        <Row className={'border-bottom-grey pR-10 pL-10 pB-2 mB-2'}>
          <Col className={'w100p'}>
            <h1 className={'txtcenter'}>Gestion de contenu</h1>
            <Row>
              <div>
                <h2>Filtre:</h2>
              </div>
              <Col>
                <Input type='text' name='title' placeholder='Titre' onChange={this.handleChange.bind(this)} />
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className={''}>
          <Col>
            <Table>
              <thead className={'bg-ititoca yellow-ititoca'}>
                <tr >
                  <th>#</th>
                  <th>Titre</th>
                  <th>Type</th>
                  <th>Auteur</th>
                  <th>Status</th>
                  <th className={'txtcenter'}>Dernière modif.</th>
                  <th className={'txtcenter'}>Action</th>
                </tr>
              </thead>
              {contentList.map((content) => {
                let publishButton = <Button id={content._id} className={'mR-5'} color='success' onClick={this.publishContent.bind(this)}>Publier</Button>
                let archiveButton = <Button id={content._id} color='danger' onClick={this.archiveContent.bind(this)}>Archiver</Button>
                let deleteButton = <Button id={content._id} color='danger' onClick={this.deleteContent.bind(this)}>Supprimer</Button>

                let pub = 'PUBLISHED', wait = 'WAITING_FOR_VALIDATION', arch = 'ARCHIVED'
                let date = new Date(content.created_date)
                let year = date.getFullYear(), month = date.getMonth()+1, dt = date.getDate()
                let index = contentList.indexOf(content) + 1
                if (dt < 10) { dt = '0' + dt }
                if (month < 10) { month = '0' + month }
                return (<tbody key={index}>
                  <tr>
                    <td>{index}</td>
                    <td><NavLink tag={Link} to='/modifyContent' id={content._id} onClick={this.sendContentID.bind(this)}>{content.title}</NavLink></td>
                    <td>{content.type}</td>
                    <td>{content.author_id.pseudo}</td>
                    <td>{content.status === pub ? 'Publié' : (content.status === wait ? 'En attente' : 'Archivé' )}</td>
                    <td className={'txtcenter'}>{dt+'-' + month + '-'+year}</td>
                    <td className={'txtcenter'}>
                      {content.status === wait || content.status === arch ? publishButton : null}
                      {content.status === pub || content.status === wait ? archiveButton : null }
                      {content.status === arch && deleteButton}
                    </td>
                  </tr>
                </tbody>)})}
            </Table>
          </Col>
        </Row>
      </Container>
    )
  }
}

function mapDispatchToProps (dispatch) {
  return {
    dataActions: bindActionCreators(dataActions, dispatch)
  }
}

export default connect(null, mapDispatchToProps)(Search)

export { Search }



// WEBPACK FOOTER //
// ./src/components/ManageContent.js